/**
 * @deprecated this ui element is deprecated. Use FreeCarousel on SwiperJs instead.
 * */
export {
  FreeCarousel as FreeCarouselLegacy,
  FreeBullets as FreeBulletsLegacy,
  FreeCarouselItem as FreeCarouselItemLegacy,
} from './ui';
